export class BookingQuoteModel {
    nameId: string;
    mode: string;
    remarks: string;
    signatureImage: string;
    expiryDays: number;
    isAlert :boolean
    disableQuotesExpiry:boolean;
    constructor() {
        this.nameId = '';
        this.remarks = '';
        this.signatureImage = '';
        this.mode = '';
        this.isAlert = false;
        this.disableQuotesExpiry = (localStorage.getItem('settings')) ? JSON.parse((localStorage.getItem('settings'))).disableQuotesExpiry : '';
        this.expiryDays = (localStorage.getItem('settings')) ? JSON.parse((localStorage.getItem('settings'))).quotesExpiryDays : true;
    }
}